import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FolderSdk } from '../sdks/folder.sdk';

@Injectable({
	providedIn: 'root'
})
export class ImportManager {
	constructor(private folderSdk: FolderSdk) {
	}

	public importFolders(caseId: string): Observable<void> {
		return this.folderSdk.import(caseId);
	}
}
